import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getOverview = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agentOverview.overview;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getChartOptions = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.agentOverview.chartOptions}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getChart = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agentOverview.chart;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const overviewService = {
  getOverview,
  getChartOptions,
  getChart,
};
